export default __webpack_public_path__ + "static/media/background.91074e73.svg";